import request from '@/utils/request'

export function index(params) {
    return request({
        url: 'visitors/guest_car_types',
        method: 'get',
        params: params
    })
}

export function inventory(params) {
    return request({
        url: 'visitors/guest_car_type/inventory',
        method: 'get',
        params: params
    })
}

export function show(id) {
    return request({
        url: `/visitors/guest_car_types/${id}`,
        method: 'get'
    })
}

export function store(data) {
    return request({
        url: `visitors/guest_car_types`,
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `visitors/guest_car_types/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(data) {
    return request({
        url: `visitors/guest_car_types/${data.id}`,
        method: 'delete',
    })
}
